import Utils from '@/common/utils/utils';
import { Checkbox, FormControlLabel, IconButton, TextField } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import { handleInputBlur, onChangeValue } from '../../handler/EditionListHandler';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function NewLineEdition({
    setHasError,
    edition,
    indexEdition,
    provided,
    snapshot,
    setEditionList,
    hasError,
    setIsEdit,
    setOrderItem
}) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const removeNewLine = (index, setEditionLists) => {
        setEditionList(prev => {
            const prevClone = cloneDeep(prev);
            if (index !== -1) {
                prevClone.splice(index, 1);
            }
            setOrderItem(prevState => prevState - 1);
            return prevClone;
        });
    }

    return (
        <div key={edition.id}
            className={`item-edition ${snapshot.isDragging ? 'dragging' : ''}`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
        >
                    <div key={edition.id} className={`edition-new-content ${hasError || edition.error ? 'class-show-error' : ''}`}>
                        {/* select box  */}
                        <div className='edition-new-trial'>
                            <FormControlLabel
                                className="tag-item custom-radio"
                                control={
                                    <Checkbox
                                        disabled={true}
                                    />
                                }
                                data-cy="render-field-edition-checkbox"
                            />
                        </div>
                        {/* name  */}
                        <div className='edition-new-name'>
                            <TextField
                                variant="outlined"
                                className="input-add-newline-edition"
                                placeholder={trI18n('CM-PLACEHODER-EDITION-NAME')}
                                onChange={(e) => onChangeValue(e, setEditionList, indexEdition, setHasError, setIsEdit)}
                                onBlur={(e) => handleInputBlur(setEditionList, indexEdition, setHasError)}
                                value={edition?.name}
                                error={!Utils.isEmptyString(edition?.error)}
                                helperText={tr(I18n.get(edition.error)?.replace('{{maxLength}}', ProductManagementConstant.MAX_LENGTH_NAME))}
                            />
                        </div>
                        {/* action */}
                        <div className="btn-delete-newline table-row-top edition-new-remove">
                            <IconButton onClick={() => removeNewLine(indexEdition, setEditionList)}>
                                <img src="/assets/image/delete-icon.svg" alt="" />
                            </IconButton>
                        </div>
                    </div>
            </div>
    );
}
